(function () {
    'use strict';
    /*
     * Copyright (c) 2016 In Hand Health.
     * All rights reserved.
     */

    /**
     * This directive is responsible for displaying a braintree form.
     */
    angular
        .module('ihh-common-web')
        .directive('paymentMethodEntry', paymentMethodEntry);

    paymentMethodEntry.$inject = ['PaymentMethodEntryConstants', '$timeout'];

    function paymentMethodEntry(PaymentMethodEntryConstants, $timeout) {
        return {
            restrict: 'E',
            transclude: true,
            scope: {
                clinicId: '=',
                onPaymentMethodReceivedCallback: '&',
                cleanUp: '&'
            },
            controller: 'PaymentMethodEntryCtrl',
            controllerAs: 'PaymentMethodEntryVm',
            templateUrl: 'payment-method-entry/payment-method-entry.tpl.html',
            link: function ($scope) {
                $scope.$on(PaymentMethodEntryConstants.notification.setPaymentMethod, function () {
                    $timeout(function () {
                        angular.element('#checkoutSubmit').click();
                    });
                });
            }
        };
    }
})();


